import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Project } from '../models/project/project.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { UpdateProjectStageCount } from '../models/project/update-project-stage-count.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectService extends RequestService<Project> {
  static PATH = '/project';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ProjectService.PATH, globalService.debugUrl);
  }

  updateStageCount(req: UpdateProjectStageCount) {
    return this.httpClient.post<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ProjectService.PATH}/updateStageCount`,
      req
    );
  }
}
